<template>
  <div>
    <DataTable
      title="Admin Blog"
      @delete="deleteBlog"
      @create="createBlog"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    />
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-blog',
  components: {
    DataTable
  },
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'title',
          value: 'title'
        },
        {
          name: 'priority',
          value: 'priority'
        },
        {
          name: 'tags',
          value: 'tags'
        },
        {
          name: 'status',
          value: 'status'
        }
      ],
      data: [],
      operations: []
    }
  },
  created () {
    this.init()
  },
  mounted () {
    this.addQuillStyling()
  },
  methods: {
    addQuillStyling () {
      var link = document.createElement('link')
      link.setAttribute('rel', 'stylesheet')
      link.setAttribute('href', 'https://cdn.quilljs.com/1.2.6/quill.snow.css')
      document.body.appendChild(link)
    },
    init () {
      this.$network_utils.getAllBlogs().then(response => {
        this.data = response
      })
    },
    deleteBlog (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.title,
        item_name: delete_data.title,
        method: 'deleteBlog',
        method_params: { id: delete_data.id }
      })
    },
    createBlog () {
      this.create({
        modal_width: 1500,
        designator: 'admin-blog-modal',
        component_name: 'AdminBlogForm',
        is_create: true,
        modal_title: 'Create new Blog'
      })
    },
    editClick (data) {
      this.create({
        modal_width: 1500,
        designator: 'admin-blog-modal',
        component_name: 'AdminBlogForm',
        data,
        modal_title: data.title
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
